import { Provider } from '@angular/core';
import { IReportDialogOptions, ReportHistoryEventType } from '@phx-erp/shared';
import { IReportTriggerExecution, REPORT_TRIGGER_EXECUTION } from '@phx-erp/shared-ui';
import { ReportPrintUIService } from '../services/report-print-ui.service';
import { ReportService } from '../services/report.service';
import { ReportContext } from '../services/type-interfaces';

export function reportTriggerExecutionFactory(
    reportService: ReportService,
    reportPrintUIService: ReportPrintUIService,
): IReportTriggerExecution {
    return {
        executeReportWithTriggers: (reportContext, action) =>
            reportService.executeReportWithTriggers(
                reportContext as ReportContext,
                action as ReportHistoryEventType,
            ),
        showPreviewDialog: (reportContext, dialogOptions?: IReportDialogOptions) =>
            reportPrintUIService.showPreviewDialog(reportContext as ReportContext, dialogOptions),
    };
}

export const REPORT_TRIGGER_EXECUTION_PROVIDERS: Provider[] = [
    {
        provide: REPORT_TRIGGER_EXECUTION,
        useFactory: reportTriggerExecutionFactory,
        deps: [ReportService, ReportPrintUIService],
    },
];
